<template>
  <div class="inner-link">
    <router-link
      v-if="isRouterLink"
      :to="linkProps.to"
      :class="linkClass"
      :target="linkProps.target"
    >
      <slot />
    </router-link>
    <a
      v-else
      :href="linkProps.href"
      :class="linkClass"
      :target="linkProps.target"
      :rel="linkProps.rel"
    >
      <slot />
    </a>
  </div>
</template>

<script>
export default {
  name: 'InnerLink',
  props: {
    to: {
      type: [String, Object],
      default: ''
    },
    href: {
      type: String,
      default: ''
    },
    target: {
      type: String,
      default: '_self'
    },
    rel: {
      type: String,
      default: 'noopener noreferrer'
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    isRouterLink() {
      return this.to && !this.href
    },
    linkProps() {
      if (this.isRouterLink) {
        return {
          to: this.to,
          target: this.target
        }
      } else {
        return {
          href: this.href || '#',
          target: this.target,
          rel: this.target === '_blank' ? this.rel : null
        }
      }
    },
    linkClass() {
      return [
        'inner-link-item',
        this.className
      ].filter(Boolean).join(' ')
    }
  }
}
</script>

<style lang="scss" scoped>
.inner-link {
  display: inline-block;
}

.inner-link-item {
  color: inherit;
  text-decoration: none;
  display: inline-block;
  width: 100%;
  height: 100%;
}

.inner-link-item:hover {
  text-decoration: none;
}

.inner-link-item:focus {
  outline: none;
}
</style>